import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy, AfterViewInit, OnChanges, SimpleChanges,
  Output, EventEmitter } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';

import { AuthService } from './../../../../services/auth.service';
import { MemberService } from './../../../../rest/api/member.service';
import { HelperService } from './../../../../services/helper.service';
import { ToastrService } from 'ngx-toastr';
import { SpaceService } from './../../../../services/space.service';

import _ from 'lodash';

@Component({
  selector: 'app-edit-twodimension',
  animations: [
    trigger('openClose', [
      state('open', style({
        // transform: 'scale(1) translate(-40%, 60px)',
        display: 'block',
        opacity: '1',
        visibility: 'visible'
      })),
      state('closed', style({
        // transform: 'scale(0) translate(-40%, 60px)',
        animationDuration: '5s',
        animationDelay: '5s',
        display: 'block',
        opacity: '0',
        visibility: 'hidden'
      })),
      transition('open => closed', [
        animate('0.6s')
      ]),
      transition('closed => open', [
        animate('0.6s')
      ]),
    ]),
    trigger('toggleHighlightReels', [
      state('open', style({
        height: '220px',
        bottom: 0,
      })),
      state('closed', style({
        height: '0',
        padding: '0',
        bottom: 0,
      })),
      transition('open => closed', [
        animate('0.4s')
      ]),
      transition('closed => open', [
        animate('0.4s')
      ]),
    ]),
    trigger('openCloseToaster', [
      state('open', style({
        width: '310px',
        right: '60px',
        padding: '15px 24px',
        opacity: '1',
        visibility: 'visible'
      })),
      state('closed', style({
        opacity: '0',
        right: '60px',
        padding: '0',
        visibility: 'hidden'
      })),
      transition('open => closed', [
        animate('0.4s')
      ]),
      transition('closed => open', [
        animate('0.4s')
      ]),
    ]),
    trigger('openCloseButton', [
      state('open', style({
        width: '450px',
        top: '100px',
      })),
      state('closed', style({
        opacity: '0',
        width: '0px',
        right: '0',
        padding: '0',
      })),
      transition('open => closed', [
        animate('0.4s')
      ]),
      transition('closed => open', [
        animate('0.4s')
      ]),
    ]),
  ],
  templateUrl: './edit-twodimension.component.html',
  styleUrls: ['./edit-twodimension.component.scss']
})
export class EditTwodimensionComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() cameraPosition;
  @Input() spaceData;
  @Input() mediaData;
  @Input() selectedMedia;
  @Input() showinfoHotspotData;
  @Input() hotspotListData;
  @Input() infohotspotListData;
  @Input() snapshotListData;

  @Output() closeEditVirtualToursEmit = new EventEmitter();
  @Output() seletedMediaEmit = new EventEmitter();
  @Output() setInitialViewEmit = new EventEmitter();
  @Output() changeSpaceConfigEmit = new EventEmitter();
  @Output() viewSnapShotModalEmit = new EventEmitter();
  @ViewChild('rendererContainerEdit') rendererContainerEdit: ElementRef;
  @ViewChild('cssRendererEditContainer') cssRendererEditContainer: ElementRef;

  loading = false;

  highlightReelData: any;

  accessToken: any;
  highlightReelView = false;
  buttonoverlayView = false;
  // loading = true;
  linkDisplay =  false;
  infoDisplay =  false;
  toggle = false;
  sidebarType: any;
  sidebarTypeList = [
    'image',
    'hotspot',
    'infohotspot',
    'snapshot',
    'setting'
  ];

  isSnapshotCameraEnabled = false;
  snapShotResponse = { status: '', message: 0, filePath: '' };
  snapShotSucess = false;
  snapShotObjErr: any;
  snapshotClicked = false;

  addHightLightReelPhotos = false;
  highlightreelAdded: any;

  // Three js basic controls scene camera
  animateId: any;
  controls = null;
  rendererEdit = null;
  scene = null;
  camera = null;
  ambientLight = null;
  pointLight = null;
  geometry = null;
  material = null;
  raycaster = new THREE.Raycaster();

  // Canvas, mouse config
  canvasConfig = {
    manualControl: false,
    CANVAS_HEIGHT: 850,
    CANVAS_WIDTH: 1200,
    CANVAS_CENTER_X: 0,
    CANVAS_CENTER_Y: 0,
  };

  mouse = new THREE.Vector2(0, 0);

  // SPHERE
  sphereMesh = null;

  hotspotColor = '#ffc378';
  hotspotsMesh = [];
  hotspotsInfoMesh = [];

  clickedPosition: any;
  selectedMesh: any;

  // Edit hotspots
  editHotspots: any;

  hotspotType = 'link';

  // Camera rotation codes
  cameraConfig = {
    isTweening: false,
    isUserInteracting: false,
    onMouseDownMouseX: 0,
    onMouseDownMouseY: 0,
    lon: 0,
    onMouseDownLon: 0,
    lat: 0,
    onMouseDownLat: 0,
    phi: 0,
    theta: 0,
    clientX: 0,
    clientY: 0,
    controlsSpeed: 600
  };

  cssSceneEdit = null;
  cssRendererEdit = null;

  hotspotCreateClicked = false;

  hotspotDragging = false;
  draggingId = null;

  currentMesh = null;

  deletedSnapshotData = [];
  // counter = 0;
  constructor(
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    private toastr: ToastrService,
    public spaceService: SpaceService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    // this.initScene();
  }

  ngOnInit() {
    const thisobject = this;
    // tslint:disable-next-line:only-arrow-functions
    $('body').on('click', '.hotspot-pulse-edit', function(event) {
      if ($(this).attr('id') && !thisobject.linkDisplay) {
        thisobject.hotspotClickedEvent($(this).attr('id'));
      }
    });

    // tslint:disable-next-line:only-arrow-functions
    $('body').on('click', '.info-outer-edit', function(event) {
      if ($(this).attr('id') && !thisobject.infoDisplay) {
        thisobject.infoHotspotClickedEvent($(this).attr('id'));
      }
    });

    // Dragging
    // tslint:disable-next-line:only-arrow-functions
    $('body').on('mousedown', '.info-outer-edit', function(event) {
      if ($(this).attr('id') && thisobject.infoDisplay && thisobject.selectedMesh && thisobject.selectedMesh.name === $(this).attr('id')) {
        thisobject.draggingId = $(this).attr('id');
        if (thisobject.draggingId && thisobject.draggingId !== $(this).attr('id')) {
          return;
        }
        if (thisobject.controls) {
          thisobject.controls.enableRotate = false;
        }
        thisobject.hotspotDragging = true;
        return false;
      }
    });

    // tslint:disable-next-line:only-arrow-functions
    $('body').on('mousedown', '.hotspot-pulse-edit', function(event) {
      if ($(this).attr('id') && thisobject.linkDisplay && thisobject.selectedMesh && thisobject.selectedMesh.name === $(this).attr('id')) {
        thisobject.draggingId = $(this).attr('id');
        if (thisobject.draggingId && thisobject.draggingId !== $(this).attr('id')) {
          return;
        }
        if (thisobject.controls) {
          thisobject.controls.enableRotate = false;
        }
        thisobject.hotspotDragging = true;
        return false;
      }
    });


    // $(document).on('show.bs.modal', '.modal', function (event) {
    //     const zIndex = 1040 + (10 * $('.modal:visible').length);
    //     $(this).css('z-index', zIndex + ' !important');
    //     setTimeout(function() {
    //         $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
    //     }, 0);
    // });

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.selectedMedia && changes.selectedMedia.currentValue && this.currentMesh) {
      this.removeComponentProperties();
      this.init();
    }
    if (changes && changes.spaceData && changes.spaceData.currentValue) {
      this.getSnapshotList();
      this.getHighlightReelList();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.init();
    }, 1000);


  }

  init() {
    this.initScene();
    this.initCameraAndLight();
    this.initControls();
    this.createCubes();
    this.animate();
  }

  initScene() {
    this.rendererEdit = new THREE.WebGLRenderer({ antialias: true, preserveDrawingBuffer: true });
    this.rendererEdit.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );
    this.rendererContainerEdit.nativeElement.appendChild( this.rendererEdit.domElement );
    this.scene = new THREE.Scene();
    // Css renderer
    this.cssSceneEdit = new THREE.Scene();
    this.cssRendererEdit = new THREE.CSS2DRenderer();

    this.canvasConfig.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererContainerEdit.nativeElement).width));
    this.canvasConfig.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererContainerEdit.nativeElement).height));
    this.canvasConfig.CANVAS_CENTER_X = this.canvasConfig.CANVAS_WIDTH / 2;
    this.canvasConfig.CANVAS_CENTER_Y = this.canvasConfig.CANVAS_HEIGHT / 2;
    // Css renderer
    this.cssRendererEdit.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );
    this.cssRendererEdit.domElement.style.position = 'absolute';
    this.cssRendererEdit.domElement.style.top = 0;
    this.cssRendererEditContainer.nativeElement.appendChild(this.cssRendererEdit.domElement);
  }

  initCameraAndLight() {
    this.camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 1000 );
    this.camera.position.set( 0, 0, 0.001 );
    this.ambientLight = new THREE.AmbientLight( 0xcccccc, 0.4 );
    this.scene.add( this.ambientLight );
    this.pointLight = new THREE.PointLight( 0xffffff, 0.8 );
    this.camera.add( this.pointLight );
    this.scene.add( this.camera );
  }

  initControls() {
    this.controls = new THREE.OrbitControls( this.camera, this.cssRendererEdit.domElement );
    this.controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
    this.controls.dampingFactor = 0.1;
    this.controls.rotateSpeed = 0.04;
    this.controls.screenSpacePanning = false;
    this.controls.enableZoom = false;
    this.controls.maxDistance = 20;
  }

  createCubes() {
    const materialArray = this.createCubeTextureMaterial(this.selectedMedia, 1);
    const skyBox = new THREE.Mesh( new THREE.BoxGeometry( 200, 200, 200 ), materialArray );
    skyBox.name = this.selectedMedia.uuid;
    this.currentMesh = skyBox;
    this.scene.add(skyBox);
    this.addMediaHotspot(this.selectedMedia);
    const infoHotspotData = _.filter(this.infohotspotListData, {media_id: this.selectedMedia.uuid});
    this.addMediaInfoHotspot(infoHotspotData);
  }

  createCubeTextureMaterial(mediaData, opacityValue) {
    const materialArray = [];
    const loader = new THREE.TextureLoader();
    const textureRight = loader.load( mediaData.cubemap[0] ); // Right
    const textureLeft = loader.load( mediaData.cubemap[5] ); // left
    const textureTop = loader.load( mediaData.cubemap[1] ); // top
    const textureBottom = loader.load( mediaData.cubemap[2] ); // bottom
    const textureBack = loader.load( mediaData.cubemap[4] ); // back
    const textureFront = loader.load( mediaData.cubemap[3] ); // front
    materialArray.push(new THREE.MeshBasicMaterial( { map: textureRight, side: THREE.DoubleSide, transparent: true, opacity: opacityValue }));
    materialArray.push(new THREE.MeshBasicMaterial( { map: textureLeft, side: THREE.DoubleSide, transparent: true, opacity: opacityValue  }));
    materialArray.push(new THREE.MeshBasicMaterial( { map: textureTop, side: THREE.DoubleSide, transparent: true, opacity: opacityValue  }));
    materialArray.push(new THREE.MeshBasicMaterial( { map: textureBottom, side: THREE.DoubleSide, transparent: true, opacity: opacityValue  }));
    materialArray.push(new THREE.MeshBasicMaterial( { map: textureBack, side: THREE.DoubleSide, transparent: true, opacity: opacityValue  }));
    materialArray.push(new THREE.MeshBasicMaterial( { map: textureFront, side: THREE.DoubleSide, transparent: true, opacity: opacityValue  }));
    return materialArray;
  }

  getLatLng(vector, radius) {
    radius = radius || 200;
    const latRads = Math.acos(vector.y / radius);
    const lngRads = Math.atan2(vector.z, vector.x);
    const lat = (Math.PI / 2 - latRads) * (180 / Math.PI);
    const lng = (Math.PI - lngRads) * (180 / Math.PI);
    return {
      lat, lng
    };
  }

  vector3toLonLat( vector3 ) {
      vector3.normalize();
      let lng = -( Math.atan2( -vector3.z, -vector3.x ) ) - Math.PI / 2;
      // to bind between -PI / PI
      if ( lng < - Math.PI ) {
        lng += Math.PI * 2;
      }
      // latitude : angle between the vector & the vector projected on the XZ plane on a unit sphere
      // project on the XZ plane
      const p = new THREE.Vector3( vector3.x, 0, vector3.z );
      // project on the unit sphere
      p.normalize();
      // commpute the angle ( both vectors are normalized, no division by the sum of lengths )
      let lat = Math.acos( p.dot( vector3 ) );
      // invert if Y is negative to ensure teh latitude is comprised between -PI/2 & PI / 2
      if ( vector3.y < 0 ) {
        lat *= -1;
      }

      return {
        lat, lng
      };

  }


  animate() {
    this.animateId = requestAnimationFrame(this.animate.bind(this));
    if (this.rendererEdit) {
      // this.updateMetaTagsRotationOnMouseMove();
      this.controls.update();
      TWEEN.update();
      this.render();
    }
  }

  render() {
    if (this.rendererEdit) {
        this.rendererEdit.render(this.scene, this.camera);
    }
    if (this.cssRendererEdit) {
      this.cssRendererEdit.render( this.scene, this.camera );
    }
  }

  changeMediaEmit(response) {
    let data;
    if (response.changeHotspot) {
      data = {
        changeHotspot: response.changeHotspot,
        cameraPosition: response.cameraPosition,
        selectedMedia: response.selectedMedia
      };
      this.cameraPosition = response.cameraPosition;
      this.selectedMedia = response.selectedMedia;
    } else {
      data = response;
      this.selectedMedia = response;
    }
    this.linkDisplay = false;
    this.infoDisplay = false;

    this.removeCssComponents();
    this.createCubes();
    this.seletedMediaEmit.emit(data);
  }

  closeEditVirtualTours() {
    this.removeComponentProperties();
    this.closeEditVirtualToursEmit.emit(true);
  }

  onMouseMove( event ) {
      if (this.camera && (event.target && event.target.parentElement && event.target.parentElement.id === 'cssEdit') ||
      (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssEdit')
      ) {
          this.canvasConfig.manualControl = true;
          const canvasBounds = this.rendererEdit.getContext().canvas.getBoundingClientRect();
          this.mouse.x = ( ( event.clientX - canvasBounds.left ) / ( canvasBounds.right - canvasBounds.left ) ) * 2 - 1;
          this.mouse.y = - ( ( event.clientY - canvasBounds.top ) / ( canvasBounds.bottom - canvasBounds.top) ) * 2 + 1;
          // Drag controls
          if (this.selectedMesh && this.hotspotDragging && (this.infoDisplay || this.linkDisplay)) {
            const mousePosition = new THREE.Vector2();
            mousePosition.x = ( ( event.clientX - canvasBounds.left ) / ( canvasBounds.right - canvasBounds.left ) ) * 2 - 1;
            mousePosition.y = - ( ( event.clientY - canvasBounds.top ) / ( canvasBounds.bottom - canvasBounds.top) ) * 2 + 1;
            const rayCaster = new THREE.Raycaster();
            rayCaster.setFromCamera(mousePosition, this.camera);
            const intersects = rayCaster.intersectObjects( [this.currentMesh], true );
            if ( intersects.length > 0 ) {
              this.render();
              const draggedPosition = rayCaster.ray.at(50);
              this.selectedMesh.position.set(draggedPosition.x, draggedPosition.y, draggedPosition.z);
            }
          }
          // Drag controls
          // Image rotation
          if ( this.cameraConfig.isUserInteracting === true ) {
            this.cameraConfig.clientX = event.clientX || event.touches[ 0 ].clientX;
            this.cameraConfig.clientY = event.clientY || event.touches[ 0 ].clientY;
          }
    }

  }

  onMouseDown(event) {
    if (this.camera) {
      if ((event.target && event.target.parentElement && event.target.parentElement.id === 'editVirtualTourContainer') ||
        (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssEdit')
        ) {
        this.canvasConfig.manualControl = false;
        this.cameraConfig.isUserInteracting = true;
        this.cameraConfig.clientX = (event && event.clientX) || (event && event.touches[ 0 ].clientX);
        this.cameraConfig.clientY = (event && event.clientY) || (event && event.touches[ 0 ].clientY);
        this.cameraConfig.onMouseDownMouseX = this.cameraConfig.clientX;
        this.cameraConfig.onMouseDownMouseY = this.cameraConfig.clientY;
        this.cameraConfig.onMouseDownLon = this.cameraConfig.lon;
        this.cameraConfig.onMouseDownLat = this.cameraConfig.lat;
      }
    }
  }

  onMouseUp(event) {
    if (this.camera && this.controls) {
      this.controls.enableRotate = true;
      this.hotspotDragging = false;
      this.cameraConfig.isUserInteracting = false;
    }
  }

  ondblclick(event) {
    if (this.camera) {
      this.hotspotDragging = false;
      this.cameraConfig.isUserInteracting = false;
      if ((event.target && event.target.parentElement && event.target.parentElement.id === 'cssEdit') ||
        (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssEdit')
        ) {
          if (!this.linkDisplay && !this.infoDisplay) {

            const mousePosition = new THREE.Vector2();
            const canvasBounds = this.rendererEdit.getContext().canvas.getBoundingClientRect();
            mousePosition.x = ( ( event.clientX - canvasBounds.left ) / ( canvasBounds.right - canvasBounds.left ) ) * 2 - 1;
            mousePosition.y = - ( ( event.clientY - canvasBounds.top ) / ( canvasBounds.bottom - canvasBounds.top) ) * 2 + 1;

            const rayCaster = new THREE.Raycaster();
            rayCaster.setFromCamera(mousePosition, this.camera);
            const intersects = rayCaster.intersectObjects( [this.currentMesh], true );
            if ( intersects.length > 0 ) {
              this.editHotspots = undefined;
              this.clickedPosition = rayCaster.ray.at(50);
              this.createNewHotspots();
            }
          }
      }
    }
  }

  onMouseWheel(event) {
    if (this.camera && (event.target && event.target.parentElement && event.target.parentElement.id === 'cssEdit') || (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssEdit')
    ) {
      let fov;
      if (event.deltaY < 0) {
        fov = this.camera.fov - 5;
        if (fov >= 35) {
          const tween = new TWEEN.Tween(this.camera).to({fov}, 300);
          tween.onUpdate(() => {
            this.camera.updateProjectionMatrix();
          });
          tween.start();
        }
      } else if (event.deltaY > 0) {
        fov = this.camera.fov + 5;
        if (fov <= 75) {
          const tween = new TWEEN.Tween(this.camera).to({fov}, 300);
          tween.onUpdate(() => {
            this.camera.updateProjectionMatrix();
          });
          tween.start();
        }
      }
    }
  }

  onDocumentMouseWheel( event ) {
    if (this.camera) {
      // Image rotation
      if (this.camera && (event.target && event.target.parentElement && event.target.parentElement.id === 'cssEdit') ||
      (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssEdit')
      ) {
          $('body').addClass('overflowHidden');
          const deltaY = event.deltaY * 0.05;
          if (deltaY < 0) {
            // Zoom in
            this.zoomInOut('in');
          } else {
            // Zoom out
            this.zoomInOut('out');
          }
      } else {
        $('body').removeClass('overflowHidden');
      }
    }
  }

  zoomInOut( zoomType ) {
    if (this.cameraConfig.isTweening) {
      return;
    }
    let fov;
    const cameraFov = this.camera.fov;
    if (zoomType === 'in') {
      fov = cameraFov - 15;
      if (fov >= 30) {
        this.cameraConfig.isTweening = true;
        const tween = new TWEEN.Tween(this.camera).to({fov}, 300);
        tween.onUpdate(() => {
          this.camera.updateProjectionMatrix();
        });
        tween.onComplete(() => {
          this.cameraConfig.isTweening = false;
        });
        tween.start();
      }
    } else if (zoomType === 'out') {
      fov = cameraFov + 15;
      if (fov <= 75) {
        this.cameraConfig.isTweening = true;
        const tween = new TWEEN.Tween(this.camera).to({fov}, 300);
        tween.onUpdate(() => {
          this.camera.updateProjectionMatrix();
        });
        tween.onComplete(() => {
          this.cameraConfig.isTweening = false;
        });
        tween.start();
      }
    }
  }

  createNewHotspots() {
    // Closing sidebar
    this.closeSidebar();
    if (this.hotspotType === 'link') {
      const color = this.hotspotColor;
      let content = '';
      content += '<div class="hotspot-pulse-edit" id="new_link" data-color="' + color + '" style="border: 5px solid ' + color + '">';
      content += '<div class="pulse" style="border: 2px solid ' + color + '"></div>';
      content += '</div>';
      const element = document.createElement('div');
      element.innerHTML = content;
      const sprite = new THREE.CSS2DObject( element );
      sprite.name = 'new_link';
      sprite.position.set(this.clickedPosition.x, this.clickedPosition.y, this.clickedPosition.z);
      this.selectedMesh = sprite;
      this.hotspotsMesh.push(sprite);
      this.currentMesh.add( sprite );
      this.linkDisplay = true;
    } else if (this.hotspotType === 'info') {
      let content = '';
      content += '<div class="info-outer-edit" id="new_info">';
      content += '<div class="info-hotspot-pulse">';
      content += '<div class="info-icon">';
      content += '<img src="assets/images/icons/main-info.png">';
      content += '</div>';
      content += '</div>';
      content += '</div>';
      const element = document.createElement('div');
      element.innerHTML = content;

      const sprite = new THREE.CSS2DObject( element );
      sprite.name = 'new_info';
      sprite.position.set(this.clickedPosition.x, this.clickedPosition.y, this.clickedPosition.z);
      this.selectedMesh = sprite;
      this.hotspotsInfoMesh.push(sprite);
      this.currentMesh.add( sprite );
      this.infoDisplay = true;
    }
  }


  // Link hotspot
  addMediaHotspot(jsonData) {
    if (jsonData && jsonData.hotspot) {
      let i;
      for (i = 0; i < jsonData.hotspot.length; i++) {
        const hotspots = jsonData.hotspot[i];
        this.createMediaHotspot(hotspots);
      }
    }
  }

  createMediaHotspot(hotspot) {
    const color = hotspot.color ? hotspot.color : this.hotspotColor;
    let content = '';
    content += '<div class="hotspot-pulse-edit" data-id="' + hotspot.uuid + '" id="' + hotspot.uuid + '" data-color="' + color + '" style="border: 5px solid ' + color + '">';
    content += '<div class="pulse" style="border: 2px solid ' + color + '" >';
    // content += '<div class="hotspot-title"><p> ' + hotspot.title + ' </p></div>';
    content += '</div>';
    content += '</div>';
    const element = document.createElement('div');
    element.innerHTML = content;

    const sprite = new THREE.CSS2DObject( element );
    sprite.position.set(hotspot.coordinates.x, hotspot.coordinates.y, hotspot.coordinates.z);
    sprite.name = hotspot.uuid;
    sprite.hotspot_type = 'link';
    sprite.userData = hotspot;
    this.hotspotsMesh.push(sprite);
    this.currentMesh.add( sprite );
  }
  // Link hotspot

  // Info hotspots
  addMediaInfoHotspot(hotspotData) {
    let i;
    for (i = 0; i < hotspotData.length; i++) {
      const hotspots = hotspotData[i];
      this.createMediaInfoHotspot(hotspots);
    }
  }

  createMediaInfoHotspot(hotspot) {
    let content = '';
    let display = 'block';
    if (!hotspot.show_info_hotspot) {
      display = 'none';
    }
    content += '<div class="info-outer-edit" style="display: "' + display + '" id="' + hotspot.uuid + '" data-id="' + hotspot.uuid + '">';
    content += '<div class="info-hotspot-pulse">';
    content += '<div class="info-icon">';
    content += '<img src="assets/images/icons/main-info.png">';
    content += '</div>';
    content += '</div>';
    content += '</div>';
    const element = document.createElement('div');
    element.innerHTML = content;
    const sprite = new THREE.CSS2DObject( element );
    sprite.position.set(hotspot.coordinates.x, hotspot.coordinates.y, hotspot.coordinates.z);
    sprite.name = hotspot.uuid;
    sprite.visible = hotspot.show_info_hotspot;
    sprite.hotspot_type = 'info';
    sprite.userData = hotspot;
    this.hotspotsInfoMesh.push(sprite);
    this.currentMesh.add( sprite );
  }

  infoHotspotClickedEvent(uuid) {
    const hotspotMesh = _.find(this.hotspotsInfoMesh , {name: uuid });
    const hotspotData =  _.find(this.infohotspotListData , {uuid});
    if (hotspotData) {
      // Closing sidebar
      this.closeSidebar();
      this.editHotspots = hotspotData;
      this.linkDisplay = false;
      this.infoDisplay = true;
      this.hotspotType = 'info';
      this.selectedMesh = hotspotMesh;
    }
  }

  // Info hotspots

  hotspotClickedEvent(uuid) {
    const hotspotMesh = _.find(this.hotspotsMesh , {name: uuid });
    const hotspotData =  _.find(this.selectedMedia.hotspot , {uuid});
    if (hotspotData) {
      // Closing sidebar
      this.closeSidebar();
      this.editHotspots = hotspotData;
      this.linkDisplay = true;
      this.infoDisplay = false;
      this.hotspotType = 'link';
      this.selectedMesh = hotspotMesh;
    }
  }

  resizeHandler(event) {

    if (this.rendererEdit) {
      this.canvasConfig.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererContainerEdit.nativeElement).width));
      this.canvasConfig.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererContainerEdit.nativeElement).height));
      this.camera.aspect = this.canvasConfig.CANVAS_WIDTH / this.canvasConfig.CANVAS_HEIGHT;
      this.camera.updateProjectionMatrix();
      this.rendererEdit.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );
      // Css renderer
      this.cssRendererEdit.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );
    }
  }

  toggleMenuEmit(response) {
    // Closing info hotspot and hotspot create or update modal box
    this.closeHotSpotBoxEmit(undefined);
    this.sidebarType = response.sidebarType;
    this.addHightLightReelPhotos = false;
    if (this.sidebarType === 'camera') {
      this.highlightReelView = false;
      this.isSnapshotCameraEnabled = !this.isSnapshotCameraEnabled;
      this.toggle = false;
    } else if (this.sidebarType === 'highlightreel') {
      this.highlightReelView = !this.highlightReelView;
      if (this.highlightReelView) {
        this.addHightLightReelPhotos = true;
      }
      this.isSnapshotCameraEnabled = false;
      this.toggle = false;
    } else if (response.toggle && this.sidebarTypeList.includes(this.sidebarType)) {
      this.highlightReelView = false;
      this.isSnapshotCameraEnabled = false;
      this.toggle = response;
    } else {
      this.highlightReelView = false;
      this.isSnapshotCameraEnabled = false;
      this.toggle = false;
    }
    // sidebarType
  }

  closeSidebar() {
    this.toggle = false;
    this.sidebarType = undefined;
    this.addHightLightReelPhotos = false;
    this.isSnapshotCameraEnabled = false;
    this.highlightReelView = false;
  }

  removeComponentProperties() {
    const gl = this.rendererEdit.getContext('webgl');
    if (gl) {
      try {
        gl.getExtension('WEBGL_lose_context').loseContext();
      } catch {
        console.log('error');
      }
    }

    this.removeCssComponents();

    cancelAnimationFrame(this.animateId); // Stop the animation
    this.rendererEdit.domElement.addEventListener('dblclick', null, false); // remove listener to render
    if (this.scene && this.currentMesh) {
      this.scene.remove(this.currentMesh);
    }
    this.currentMesh = undefined;
    this.scene = null;
    this.cssSceneEdit = null;
    this.camera = null;
    this.controls = null;
    this.empty(this.rendererContainerEdit.nativeElement);
    // this.empty(this.cssRendererEditContainer.nativeElement);
    this.removeData();
  }

  removeCssComponents() {
      if ($('.hotspot-pulse-edit')) {
        $('.hotspot-pulse-edit').each(function() {
          $(this).remove();
        });
      }
      if ($('.info-outer-edit')) {
        $('.info-outer-edit').each(function() {
          $(this).remove();
        });
      }
      let i;
      for (i = 0; i < this.hotspotsMesh.length; i++) {
          if (this.hotspotsMesh[i]) {
            this.currentMesh.remove(this.hotspotsMesh[i]);
          }
      }
      this.hotspotsMesh = [];
      // Remove info hotspot mesh
      let j;
      for (j = 0; j < this.hotspotsInfoMesh.length; j++) {
          if (this.hotspotsInfoMesh[j]) {
            this.currentMesh.remove(this.hotspotsInfoMesh[j]);
          }
      }
      this.hotspotsInfoMesh = [];
  }

  empty(elem) {
      while (elem.lastChild) {
        elem.removeChild(elem.lastChild);
      }
  }

  removeData() {
    this.cameraConfig.lat = 0;
    this.cameraConfig.lon = 0;
    this.sphereMesh = null;
  }

  deleteHotspotEmit(event) {
    if (event.uuid) {
      // Delete hotspot for link hotspot
      if (this.linkDisplay) {
        this.selectedMedia.hotspot = _.filter(this.selectedMedia.hotspot, (hotspot) => {
          return hotspot.uuid !== event.uuid;
        });
        if ($('#' + event.uuid)) {
          $('#' + event.uuid).remove();
        }

        // Remove hotspot list data
        this.hotspotListData = _.filter(this.hotspotListData, (hotspot) => {
          return hotspot.uuid !== event.uuid;
        });

      } else if (this.infoDisplay) { // Delete hotspot for info hotspot
        this.selectedMedia.hotspot_info = _.filter(this.infohotspotListData, (hotspot) => {
          return hotspot.uuid !== event.uuid;
        });
        if ($('#' + event.uuid)) {
          $('#' + event.uuid).remove();
        }

        // Remove infohotspot list data
        this.infohotspotListData = _.filter(this.infohotspotListData, (hotspot) => {
          return hotspot.uuid !== event.uuid;
        });

      }
    }
    if (this.selectedMesh) {
      this.currentMesh.remove(this.selectedMesh);
    }
    this.selectedMesh = undefined;
    this.linkDisplay = false;
    this.infoDisplay = false;
    this.canvasConfig.manualControl = false;
    this.draggingId = null;
  }

  createHotspotEmit(response) {
    if (this.linkDisplay) {
      this.selectedMesh.name = response.uuid;
      this.hotspotsMesh = _.map(this.hotspotsMesh, (hotspot) => {
        if (hotspot.name === 'new_link') {
          hotspot.name = response.uuid;
          hotspot.userData = response;
        }
        return hotspot;
      });
      if ($('#new_link')) {
        // if ($('#new_link').find('.pulse')) {
        //   const title = '<div class="hotspot-title"><p> ' + response.title + ' </p></div>';
        //   $('#new_link').find('.pulse').html(title);
        // }
        $('#new_link').attr('data-id', response.uuid);
        $('#new_link').attr('id', response.uuid);
      }
      this.linkDisplay = false;
      this.selectedMedia.hotspot.push(response);
      this.hotspotListData.push(response); // Push hotspot data
    } else if (this.infoDisplay) {
      this.hotspotsInfoMesh = _.map(this.hotspotsInfoMesh, (hotspot) => {
        if (hotspot.name === 'new_info') {
          hotspot.name = response.uuid;
          hotspot.userData = response;
        }
        return hotspot;
      });
      if ($('#new_info')) {
        $('#new_info').attr('data-id', response.uuid);
        $('#new_info').attr('id', response.uuid);
      }
      this.infoDisplay = false;
      this.selectedMedia.hotspot_info.push(response);
      this.infohotspotListData.push(response); // Push infohotspot data
    }
    this.draggingId = null;
  }

  updateHotspotOrientationEmit(response) {
    this.selectedMedia.hotspot = _.map(this.selectedMedia.hotspot, (hotspot) => {
      if (hotspot.uuid === response.uuid) {
        hotspot.orientation = response.orientation;
      }
      return hotspot;
    });

    this.hotspotsMesh = _.map(this.hotspotsMesh, (hotspot) => {
      if (hotspot.uuid === response.uuid) {
        hotspot.userData.orientation = response.orientation;
      }
      return hotspot;
    });
    // Update hotspot list data
    this.hotspotListData = _.map(this.hotspotListData, (hotspot) => {
      if (hotspot.uuid === response.uuid) {
        hotspot.orientation = response.orientation;
      }
      return hotspot;
    });
  }

  updateHotspotEmit(response) {
    if (this.linkDisplay) {
      this.selectedMedia.hotspot = _.map(this.selectedMedia.hotspot, (hotspot) => {
        if (hotspot.uuid === response.uuid) {
          // if ($('#' + response.uuid) && $('#' + response.uuid).find('.pulse')) {
          //   const title = '<div class="hotspot-title"><p> ' + response.title + ' </p></div>';
          //   $('#' + response.uuid).find('.pulse').html(title);
          // }
          return response;
        }
        return hotspot;
      });

      this.hotspotsMesh = _.map(this.hotspotsMesh, (hotspot) => {
        if (hotspot.uuid === response.uuid) {
          hotspot.userData = response;
        }
        return hotspot;
      });

      this.linkDisplay = false;

      // Update hotspot list data
      this.hotspotListData = _.map(this.hotspotListData, (hotspot) => {
        if (hotspot.uuid === response.uuid) {
          return response;
        }
        return hotspot;
      });

    } else if (this.infoDisplay) {
      this.selectedMedia.hotspot_info = _.map(this.selectedMedia.hotspot_info, (hotspot) => {
        if (hotspot.uuid === response.uuid) {
          return response;
        }
        return hotspot;
      });

      this.hotspotsInfoMesh = _.map(this.hotspotsInfoMesh, (hotspot) => {
        if (hotspot.uuid === response.uuid) {
          hotspot.userData = response;
        }
        return hotspot;
      });
      this.infoDisplay = false;

      // Update info hotspot list data
      this.infohotspotListData = _.map(this.infohotspotListData, (hotspot) => {
        if (hotspot.uuid === response.uuid) {
          return response;
        }
        return hotspot;
      });

    }
    this.draggingId = null;
  }

  deleteInfoMediaHotspotEmit(response) {
    this.selectedMedia.hotspot_info = _.map(this.selectedMedia.hotspot_info, (hotspot) => {
      if (hotspot.uuid === response.uuid) {
        return response;
      }
      return hotspot;
    });

    this.infohotspotListData = _.map(this.infohotspotListData, (hotspot) => {
      if (hotspot.uuid === response.uuid) {
        return response;
      }
      return hotspot;
    });

    this.draggingId = null;
  }

  removeSphereMesh() {
    this.scene.remove(this.sphereMesh);
  }

  closeHotSpotBoxEmit(event) {
    // Bring back position of hotspot to its original place if update button is not clicked
    if (this.linkDisplay && this.draggingId) {
      const hotspotData = _.find(this.selectedMedia.hotspot, {uuid: this.draggingId});
      if (hotspotData) {
        this.selectedMesh.position.set(hotspotData.coordinates.x, hotspotData.coordinates.y, hotspotData.coordinates.z);
      }
    } else if (this.infoDisplay && this.draggingId) {
      const infoHotspot = _.find(this.infohotspotListData, {uuid: this.draggingId});
      if (infoHotspot) {
        this.selectedMesh.position.set(infoHotspot.coordinates.x, infoHotspot.coordinates.y, infoHotspot.coordinates.z);
      }
    }
    this.draggingId = null;
    this.linkDisplay = false;
    this.infoDisplay = false;
    this.canvasConfig.manualControl = false;
    this.removeNewHotspotInfoHotspot();
  }

  removeNewHotspotInfoHotspot() {
    this.draggingId = null;
    this.linkDisplay = false;
    this.infoDisplay = false;
    this.canvasConfig.manualControl = false;
    if (this.selectedMesh && this.selectedMesh.name) {
      if (this.selectedMesh.name === 'new_link') {
        if ($('#new_link')) {
          $('#new_link').remove();
        }
        this.currentMesh.remove(this.selectedMesh);
      }
      if (this.selectedMesh.name === 'new_info') {
        if ($('#new_info')) {
          $('#new_info').remove();
        }
        this.currentMesh.remove(this.selectedMesh);
      }
      this.selectedMesh = undefined;
    }
  }

  setInitialView() {
    let formData;
    formData = {
      orientation: {
        x: this.cameraConfig.lat,
        y: this.cameraConfig.lon,
        z: 0
      }
    };
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.setMediaOrientation({
      Authorization: this.accessToken,
      mediaId: this.selectedMedia.uuid,
      body: formData
    }).subscribe(response => {
      this.toastr.success('Orientation has been set successfully');
    }, err => {
      this.toastr.error('There was problem while saving orientation');
    });
    // if (!this.selectedMedia.set_initial_view) {
    //   this.memberService.setInitialView(this.accessToken, this.selectedMedia.uuid).subscribe(response => {
    //     this.selectedMedia.set_initial_view = response.data && response.data.set_initial_view ? response.data.set_initial_view : false;
    //     this.mediaData = _.map(this.mediaData,  (res) => {
    //       if (res.uuid === this.selectedMedia.uuid) {
    //         res.set_initial_view = true;
    //       } else {
    //         res.set_initial_view = false;
    //       }
    //       return res;
    //     });
    //   });
    // }
  }

  setInitialViewForVirtualTours() {
    if (!this.selectedMedia.set_initial_view) {
      this.memberService.setInitialView({
        Authorization: this.accessToken,
        id: this.selectedMedia.uuid
      }).subscribe((response: any) => {
        this.selectedMedia.set_initial_view = response && response.data && response.data.set_initial_view ? response.data.set_initial_view : false;
        this.mediaData = _.map(this.mediaData,  (res) => {
          if (res.uuid === this.selectedMedia.uuid) {
            res.set_initial_view = true;
          } else {
            res.set_initial_view = false;
          }
          return res;
        });
      });
    }
  }

  changeSpaceConfig(config) {
    this.changeSpaceConfigEmit.emit(config);
  }

  publishSpace() {
    this.memberService.publishSpace({
      Authorization: this.accessToken,
      id: this.spaceData.uuid
    }).subscribe((response: any) => {
      this.spaceData.status = response && response.data && response.data.status ? response.data.status : this.spaceData.status;
    });
  }

  emptyMediaEmit(event) {
    this.closeEditVirtualTours();
    if ($('#deleteBtnClose')) {
      $('#deleteBtnClose').click();
    }
  }

  updateMetaTagsRotationOnMouseMove() {
    let i;
    for (i = 0; i < this.hotspotsInfoMesh.length; i++) {
      const ringMesh = this.hotspotsInfoMesh[i];
      ringMesh.setRotationFromQuaternion(this.camera.quaternion);
      ringMesh.updateMatrix();
      // ringMesh.lookAt( this.camera.position );
    }

    let k;
    for (k = 0; k < this.hotspotsMesh.length; k++) {
      const ringMesh = this.hotspotsMesh[k];
      ringMesh.setRotationFromQuaternion(this.camera.quaternion);
      ringMesh.updateMatrix();
      // ringMesh.lookAt( this.camera.position );
    }
  }

  changeColorEmit(color) {
    let element;
    if (this.editHotspots) {
      element = $('#' + this.editHotspots.uuid);
    } else {
      element = $('#new_link');
    }
    if (element) {
      element.css({
        border: `2px solid ${color}`
      });
      const children = element.find('.pulse');
      if (children) {
        children.css({
          border: `6px solid ${color}`
        });
      }
    }
  }

  saveAsImage() {
    const vector = new THREE.Vector3();
    const direction = this.camera.getWorldDirection( vector );
    const coordinates = {
      x: -1 * direction.x,
      y: -1 * direction.y,
      z: -1 * direction.z
    };
    if (this.snapshotClicked) {
      return;
    }
    this.snapshotClicked = true;
    let imgData;
    try {
        const strMime = 'image/jpeg';
        imgData = this.rendererEdit.domElement.toDataURL(strMime);
        const blobBin = atob(imgData.split(',')[1]);
        const array = [];
        let i;
        for (i = 0; i < blobBin.length; i++) {
            array.push(blobBin.charCodeAt(i));
        }
        imgData = new Blob([new Uint8Array(array)], {type: 'image/png'});
        imgData = new File([imgData], 'snapshot.png');
        this.spaceService.takeSnapshot(imgData, this.selectedMedia.uuid, coordinates, this.accessToken).subscribe(
          (res) =>  {
            this.snapShotResponse = res;
            if (res && res.data) {
              this.snapShotSucess = true;
              setTimeout(() => {
                this.snapShotSucess = false;
              }, 4000);
              this.snapshotListData.push(res.data);
              this.snapshotClicked = false;
            }
          },
          (err) => {
            this.snapShotObjErr = err.error && err.error.error ? err.error.error : 'There was error while taking snapshot.';
            this.snapshotClicked = false;
          }
        );
    } catch (e) {
        console.log(e);
        this.snapshotClicked = false;
        return;
    }

  }

  b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      let offset;
      for ( offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          let i;
          for (i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
  }

  saveFile(strData, filename) {
    const link = document.createElement('a');
    if (typeof link.download === 'string') {
        document.body.appendChild(link); // Firefox requires the link to be in the body
        link.download = filename;
        link.href = strData;
        link.click();
        document.body.removeChild(link); // remove the link when done
    }
  }

  highlightReelToggle() {
    this.highlightReelView = !this.highlightReelView;
    if (this.highlightReelView) {
      this.toggle = false;
    }
  }

  getSnapshotList() {
    this.memberService.getSnapshotList({
      Authorization: this.accessToken,
      id: this.spaceData.uuid
    }).subscribe((response: any) => {
      this.snapshotListData = response && response.data ? response.data : [];
    }, err => {
      this.snapshotListData = [];
    });
  }

  getHighlightReelList() {
    this.memberService.getHighlightReelList({
      Authorization: this.accessToken,
      id: this.spaceData.uuid
    }).subscribe((response: any) => {
      const highlightReelData = response && response.data ? response.data : [];
      this.highlightReelData = _.orderBy(highlightReelData, ['position'], ['asc']);
    }, err => {
      this.highlightReelData = [];
    });
  }

  highlightreelAddedEmit(data) {
    if (data && data.response) {
      const response = data.response;
      let i;
      for (i = 0; i < response.length; i++) {
        this.highlightReelData.push(response[i]);
      }
      this.highlightreelAdded = 'Highlight reel has been added.';
      this.highlightReelData =  _.orderBy(this.highlightReelData, ['position'], ['asc']);
      setTimeout(() => {
        this.highlightreelAdded = undefined;
      }, 3000);
    }

    // Update already in highlight reel view
    if (data && data.snapshotArray) {
      this.snapshotListData = _.map(this.snapshotListData, (snapshot) => {
        if (_.includes(data.snapshotArray, snapshot.uuid)) {
          snapshot.highlight_reel = true;
        }
        return snapshot;
      });
    }

  }

  modalCloseSnapshotEmit(response) {
    if ($('#editmattertagModal')) {
      $('#editmattertagModal').modal('hide');
    }
    this. highlightReelView = false;
    this.deletedSnapshotData = [];
  }

  viewSnapShot() {
    this.snapShotSucess = false;
    this.addHightLightReelPhotos = false;
    this.isSnapshotCameraEnabled = false;
    this.toggle = true;
    this.sidebarType = 'snapshot';
  }

  deleteSnapshotEmit(response) {
    this.snapshotListData = _.filter(this.snapshotListData, (snapshot) => {
      return response.uuid !== snapshot.uuid;
    });
  }

  deleteHighlightReelEmit(highlightReel) {
    this.highlightReelData =  _.filter(this.highlightReelData, (data) => {
      return data.uuid !== highlightReel.uuid;
    });
    this.getSnapshotList();
  }

  updateHighlightReelEmit(highlightReel) {
    this.highlightReelData =  _.map(this.highlightReelData, (data) => {
      if (data.uuid === highlightReel.uuid) {
        return highlightReel;
      }
      return data;
    });
  }

  updateHighlightReelPositionEmit(response) {
    this.highlightReelData = response;
    this.highlightreelAdded = 'Highlight reel has been updated.';
    this.highlightReelData =  _.orderBy(this.highlightReelData, ['position'], ['asc']);
    setTimeout(() => {
      this.highlightreelAdded = undefined;
    }, 3000);
  }

  showHideInfoEmit(response) {
    // Check if infohotspot is in current sphere else dont create
    if (this.currentMesh.name === response.media_id) {
      const currentInfoHotspot = _.find(this.hotspotsInfoMesh, {name: response.uuid});
      if (currentInfoHotspot) {
        // If hotspot is enable show hotspot or create new one
        let display;
        if (response.show_info_hotspot) {
          display = 'block';
          currentInfoHotspot.visible = true;
        } else { // Remove hotspot or visible to false
          display = 'none';
          currentInfoHotspot.visible = false;
        }
        if ($('#' + response.uuid)) {
          $('#' + response.uuid).css('display', display);
        }
      } else {
        this.createMediaInfoHotspot(response);
      }
    }
    this.infohotspotListData = _.map(this.infohotspotListData, (data) => {
      if (data.uuid === response.uuid) {
        return response;
      }
      return data;
    });
  }

  cancelSortingEmit(response) {
    this.highlightReelData =  _.orderBy(this.highlightReelData, ['position'], ['asc']);
  }

  ngOnDestroy() {
    TWEEN.removeAll();
    this.removeComponentProperties();
  }

  deleteMediaEmit(response) {
    this.mediaData = _.filter(this.mediaData, (media) => {
      return media.uuid !== response.uuid;
    });
  }

  // openHighLightReelModal(response) {
  //   this.highlightReelView = true;
  //   this.addHightLightReelPhotos = true;
  //   if ($('#editmattertagModal')) {
  //     $('#editmattertagModal').modal('show');
  //   }
  // }

  openHighLightReelModal(response) {
    this.highlightReelView = true;
    this.addHightLightReelPhotos = true;
    this.toggle = false;
    this.linkDisplay = false;
    this.infoDisplay = false;
    if ($('#addhightlightReelBtn')) {
      setTimeout(() => {
        document.getElementById('addhightlightReelBtn').click();
      }, 100);
    }
  }

  deleteSnapshot(snapshotData) {
    this.deletedSnapshotData = snapshotData;
    $('#deleteSnapshotModal').modal({show: true});
    // document.getElementById('deleteSnapshotBtn').click();
  }

  modalCloseEmit(response) {
    this.deletedSnapshotData = [];
    if ($('#deleteSnapshotModal')) {
      $('#deleteSnapshotModal').modal('hide');
    }
    if (response) {
      this.getSnapshotList();
      this.getHighlightReelList();
    }
  }

  modalCloseSnapshotDeleteEmit(response) {
    if ($('#deleteSnapshotModal')) {
      $('#deleteSnapshotModal').modal('hide');
    }
  }

}
